import { BehkhaanRoutes } from '@shared/utils/router-paths';
import { Routes } from '@angular/router';
import { LayoutComponent } from './pages/layout.component';
import { authGuard } from '@shared/guard/auth.guard';
import { unAuthorizeGuard } from '@shared/guard/unauthorize.guard';
import { mainDataResolver } from './pages/main-data.resolver';

export const AppRoutes: Routes = [
  // ? Landing Page
  {
    path: '',
    canActivate: [unAuthorizeGuard],
    children: [
      {
        path: '',
        loadComponent: () => import("@app/pages/home/home.component").then((component) => component.HomeComponent),
        title: 'بهخوان | بهتر انتخاب کن، بهتر بخوان',
        data: {
          shouldReuse: true,
          key: 'home',
          header: true
        }
      }
    ],
  },
  // ? Feeds
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('@app/pages/layout.routing').then(layout => layout.LayoutRouting),
      }
    ],
    resolve: [mainDataResolver]
  },
  {
    path: BehkhaanRoutes.CHALLENGE_INTRO,
    loadChildren: () => import('@app/pages/challenge-intro-container/challenge-intro.routes').then(r => r.routes)
  },
  {
    path: BehkhaanRoutes.ONBOARDING,
    loadChildren:() => import('@app/pages/onboarding-container/onboarding.routes').then(r => r.ONBOARDING_ROUTES)
  },
  // // ? Sing In/Up Routes
  // {
  //   path: BehkhaanRoutes.Sign.base,
  //   loadChildren: () => import("@app/pages/sign-in/sign.module").then((module) => module.SignModule)
  // },

  // ? Messages
  {
    path: BehkhaanRoutes.message.base,
    canActivate: [authGuard],
    loadChildren: () => import('@app/pages/messages/pages/messages-page/messages.routing').then(r => r.MESSAGES_ROUTES),

  },
  // ? All Not Found Routes
  {
    path: '**',
    redirectTo: 'not-found',
  },
  // ? Not Found Page
  {
    path: BehkhaanRoutes.NotFound,
    loadComponent: () => import('@app/pages/not-found/not-found.component').then(component => component.NotFoundComponent),
  }
]
